var groupToMap = require('./group-to-map');

var group = function group(data, condition) {
  if (!condition) {
    return [data];
  }

  var groups = groupToMap(data, condition);
  var array = [];

  for (var i in groups) {
    array.push(groups[i]);
  }

  return array;
};

module.exports = group;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/group.js
// module id = 160
// module chunks = 0 1 2